import { render } from "./ListItemEvento.vue?vue&type=template&id=ff7dfde8&scoped=true"
import script from "./ListItemEvento.vue?vue&type=script&lang=js"
export * from "./ListItemEvento.vue?vue&type=script&lang=js"

import "./ListItemEvento.vue?vue&type=style&index=0&id=ff7dfde8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7dfde8"]])

export default __exports__